import React from "react";

export default function DoNotSellOrShare({ pageTitle }) {
  return (
    <div className="page__container row no-gutters width_ctrl my-3 my-md-5 pt-0 pt-md-5">
      <div className="page__content page__content-privacy px-3">
        <h1 className={"mb-4"}>{pageTitle}</h1>
        <p>
          The California Consumer Privacy Act (CCPA), provides California
          residents rights to opt-out of “sale" and “sharing." If you are a
          resident of other US states that give you rights to opt out of “sale,"
          “sharing" and/or use of personal information for “targeted
          advertising," you may also find this information helpful.{" "}
        </p>
        <p>
          The Netfilx FYC Site (“Site") may engage in certain marketing
          activities (such as behavioral advertisements promoting the Site and
          Netfilx FYC through use of cookies) using identifiers, which may
          constitute a “sale," “sharing" and/or “targeted advertising" under the
          US State Privacy Laws. Please visit the{" "}
          <a role="button" data-page="termsV2" href="/privacy-and-terms">
            Netfilx FYC Terms of Use and Privacy Statement
          </a>{" "}
          to learn more.
        </p>
        <p>
          This article explains how the Site provides you with meaningful
          choices regarding the information we may collect about you. Below, we
          describe controls that you can access in connection with the Site. We
          may update this article from time to time to reflect changes.
        </p>
        <p className="h2">Opt out of Sale and Sharing/Targeted Advertising</p>
        To opt out of “sale," “sharing" and/or “targeted advertising," click on
        the “Cookie Preferences" link in the footer of any Site page and turn
        off advertising cookies. You may also use the settings on your browser,
        devices or apps to opt out of cookies. If you opt out of advertising
        cookies, you may still see marketing messages promoting the Site and
        Netfilx FYC, but they will not be based on information collected from
        advertising cookies.
        <p className="h2">Global Privacy Control (GPC) / Universal Opt-out</p>
        Under certain US State Privacy Laws, businesses must respect opt-out
        signals received through a user selected web browser control indicating
        their choice to opt out of the sale, sharing, or use of personal
        information for targeted advertising, as specified by applicable law.
        The platforms and methods for sending and interpreting such a signal are
        not standardized and are currently evolving, with the only
        widely-recognized such signal being the Global Privacy Control (GPC).
        Where required by applicable law, we have implemented methods to
        recognize and respond to a GPC signal on the Site and will opt you out
        of setting Advertising Cookies on that browser/device. If you access the
        Site from a different browser or from the same browser on a different
        device, you will need to send a GPC signal from that browser to opt out
        again.
      </div>
    </div>
  );
}
